import { useState } from 'react';

export function useEligibilityFilters() {
  const [selectedEligibilityFilters, setSelectedEligibilityFilters] = useState<string[]>([
    'eligible',
    'unsure',
    'ineligible',
  ]);
  const [selectedFeatureBenefitsFilters, setSelectedFeatureBenefitsFilters] = useState<string[]>(
    [],
  );

  const handleRemoveEligibilityFilter = (filterToRemove: string) => {
    setSelectedEligibilityFilters(currentFilters =>
      currentFilters.filter(filter => filter !== filterToRemove),
    );
  };

  const handleRemoveFeatureBenefitsFilter = (filterToRemove: string) => {
    setSelectedFeatureBenefitsFilters(currentFilters =>
      currentFilters.filter(filter => filter !== filterToRemove),
    );
  };

  return {
    selectedEligibilityFilters,
    setSelectedEligibilityFilters,
    selectedFeatureBenefitsFilters,
    setSelectedFeatureBenefitsFilters,
    handleRemoveEligibilityFilter,
    handleRemoveFeatureBenefitsFilter,
  };
}
